import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addNotificationFailure,
  addNotificationSuccess,
  //
  deleteNotificationFailure,
  deleteNotificationSuccess,
  editNotificationFailure,
  //
  editNotificationSuccess,
  //
  fetchNotification as fetchNotificationAction,
  fetchNotificationFailure,
  fetchNotificationSuccess,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_NOTIFICATION,
  DELETE_NOTIFICATION,
  EDIT_NOTIFICATION,
  FETCH_NOTIFICATION,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchNotificationSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/notification-template?${query}`
    );
    yield put(fetchNotificationSuccess(data));
  } catch (e) {
    yield put(fetchNotificationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching notification templates!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/notification-template/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addNotificationSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/notification-template/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Notification added successfully!"));
      yield put(addNotificationSuccess());
      if (payload?.history) {
        payload.history.push("/d/notification");
      }
    }
  } catch (e) {
    yield put(addNotificationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editNotificationSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/notification-template/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Notification updated successfully!"));
      yield put(editNotificationSuccess());
    }
  } catch (e) {
    yield put(editNotificationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteNotificationSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/notification-template/${payload}`
    );
    if (data) {
      yield put(successAlert("Notification deleted successfully!"));
      yield put(deleteNotificationSuccess());
      let refreshPayload;
      try {
        const saved = JSON.parse(localStorage.getItem("notification_filter"));
        if (saved?.title) {
          refreshPayload = {
            data: { page: 1, limit: 10, title: saved.title },
          };
        }
      } catch (e) {
        refreshPayload = undefined;
      }
      yield put(fetchNotificationAction(refreshPayload));
    }
  } catch (e) {
    yield put(deleteNotificationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchNotificationFlow() {
  yield takeEvery(FETCH_NOTIFICATION, fetchNotificationSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addNotificationFlow() {
  yield takeEvery(ADD_NOTIFICATION, addNotificationSaga);
}
export function* editNotificationFlow() {
  yield takeEvery(EDIT_NOTIFICATION, editNotificationSaga);
}
export function* deleteNotificationFlow() {
  yield takeEvery(DELETE_NOTIFICATION, deleteNotificationSaga);
}
export default function* NotificationSaga() {
  yield all([
    fetchNotificationFlow(),
    addNotificationFlow(),
    editNotificationFlow(),
    deleteNotificationFlow(),
    getViewDataFlow(),
  ]);
}
